var swiper = new Swiper(".icons-wrapper", {
  slidesPerView: 3,
  spaceBetween: 27,
  loop: false,
  navigation: {
    nextEl: ".arrow-style-next",
    prevEl: ".arrow-style-prev",
  },
  breakpoints: {
    1025: {
      slidesPerView: 9,
    },
     768: {
      slidesPerView: 6,
    },
   520: {
      slidesPerView: 5,
    },
    376:{
      slidesPerView: 3.6,
      spaceBetween: 32,
    }
  },
  });